module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 3.3be17020.png";